import { AfterViewInit, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  CheckboxInputComponent,
  TextInputComponent,
  NumberInputComponent,
  SelectInputComponent,
  CalendarInputComponent,
} from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { TIMEZONE_SELECT_OPTIONS } from '@navstation-portal/shared/util/time';

@Component({
  selector: 're-next-port',
  templateUrl: './next-port.component.html',
  styleUrl: './next-port.component.css',
  imports: [
    FormsModule,
    CheckboxInputComponent,
    TextInputComponent,
    NumberInputComponent,
    SelectInputComponent,
    CalendarInputComponent,
  ],
})
export class NextPortComponent
  extends AbstractStoreConnectedSectionComponent
  implements AfterViewInit
{
  timezoneOptions = TIMEZONE_SELECT_OPTIONS;
  tabId = 'operational';
  sectionId = 'nextPort';
  events = injectDispatch(offshoreOperationalEvents);
  operationalStore = inject(OffshoreOperationalFormStore);
}
